module.exports = __webpack_public_path__ + "8bae8fa908902f39c2fcf952b9561b83.pdf";